"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thcCBDLabel = void 0;
const thcCBDLabel = (posListingsWithFilters) => {
    const { thcFilterOption, cbdFilterOption, unitFilterOption } = posListingsWithFilters;
    const thcCbdLabel = [];
    const thcRangeMessage = thcFilterOption.rangeMessage(unitFilterOption.unit);
    const cbdRangeMessage = cbdFilterOption.rangeMessage(unitFilterOption.unit);
    thcCbdLabel.push(thcRangeMessage ? `THC (${thcRangeMessage})` : 'THC');
    thcCbdLabel.push('-');
    thcCbdLabel.push(cbdRangeMessage ? `CBD (${cbdRangeMessage})` : 'CBD');
    return thcCbdLabel.join(' ');
};
exports.thcCBDLabel = thcCBDLabel;
//# sourceMappingURL=cannabinoidLabels.js.map